import AddGenusSpecialityModel from '../AddGenusSpeciality/model/AddGenusSpecialityModel';

const AddGenusSpecialityStore = {
    name: 'AddGenusSpecialityStore',
    spec: AddGenusSpecialityModel,
    saveLocally: false,
    initialState: {
        res:"Oops...Something went wrong. Please try again."
    }
}

const stores=[AddGenusSpecialityStore]

export default stores;